import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";

const NAV = [
  { id: "services", label: "Services" },
  { id: "gallery", label: "Gallery" },
  { id: "booking", label: "Book" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-black/70 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="nav-brand"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 group"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_barnett-auto-detail/artifacts/j4o56dv7_E59AF405-589D-41F4-8F13-5979ECF507B0.png"
            alt="Barnett Auto Detailing logo"
            className="h-10 sm:h-11 w-auto object-contain"
          />
          <span className="font-display font-bold tracking-tight text-base sm:text-lg whitespace-nowrap hidden sm:inline">
            BARNETT AUTO DETAILING<span className="text-[#E63946]">.</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-link-${n.id}`}
              onClick={() => go(n.id)}
              className="text-sm text-zinc-300 hover:text-white transition-colors"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="nav-call-link"
            href="tel:8134818875"
            className="hidden sm:inline-flex items-center gap-2 text-sm text-zinc-300 hover:text-white transition-colors"
          >
            <Phone className="w-4 h-4" />
            813-481-8875
          </a>
          <button
            data-testid="nav-book-button"
            onClick={() => go("booking")}
            className="cta-glow hidden sm:inline-flex items-center gap-2 bg-[#E63946] hover:bg-[#F0545E] text-white px-4 py-2 text-sm font-semibold tracking-wide"
          >
            Book Now
          </button>
          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden p-2 text-zinc-200"
            onClick={() => setOpen((s) => !s)}
            aria-label="Toggle menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="nav-mobile-panel" className="md:hidden bg-black/95 backdrop-blur-xl border-b border-white/10">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`nav-mobile-link-${n.id}`}
                onClick={() => go(n.id)}
                className="text-left py-2 text-zinc-200"
              >
                {n.label}
              </button>
            ))}
            <a
              data-testid="nav-mobile-call"
              href="tel:8134818875"
              className="flex items-center gap-2 text-zinc-200 py-2"
            >
              <Phone className="w-4 h-4" /> 813-481-8875
            </a>
            <button
              data-testid="nav-mobile-book"
              onClick={() => go("booking")}
              className="cta-glow bg-[#E63946] hover:bg-[#F0545E] text-white px-4 py-3 font-semibold"
            >
              Book Now
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
